import eraDefinitions from './gen_era_definitions.json';

interface EraDefinition {
    id: string;
    eraUnitId: string[];
    startTimeMs: number;
    endTimeMs: number;
}

// Build a lookup map from unit baseId to era definition at import time.
const unitToEra = new Map<string, EraDefinition>();
let activeEraUnits: Set<string> = new Set<string>();
let activeEra: EraDefinition | null = null;

function loadEraUnits() {
    if (activeEra != null)
        return;
    for (const era of Object.values(eraDefinitions) as EraDefinition[]) {
        const now = Date.now();
        const isActive = now >= era.startTimeMs && now < era.endTimeMs;
        if (isActive)
            activeEra = era;
        for (const unitId of era.eraUnitId) {
            unitToEra.set(unitId, era);
            if (isActive)
                activeEraUnits.add(unitId);
        }
    }
}

export function getActiveEra(): EraDefinition | null {
    loadEraUnits();
    return activeEra;
}

export function isActiveEraUnit(baseId: string): boolean {
    loadEraUnits();
    const era = unitToEra.get(baseId);
    if (!era) return false;
    const now = Date.now();
    return now >= era.startTimeMs && now < era.endTimeMs;
}

export function getEraEndDate(baseId: string): Date | null {
    loadEraUnits();
    const era = unitToEra.get(baseId);
    if (!era) return null;
    return new Date(era.endTimeMs);
}
